<template>
  <table>
    <caption>반복맞춤소식 대상자별 Daily</caption>
    <thead>
      <tr>
        <th>번호</th>
        <th>소식종류</th>
        <th>소식내용</th>
        <th>작성자</th>
        <th>스피커알림</th>
        <th>전송날짜</th>
        <th>확인시간</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="rowData in sourceList">
        <td>{{rowData.id}}</td>
        <td>{{getNewsTypeCombineText(rowData.newsType, rowData.customNewsType)}}</td>
        <td>{{rowData.boardContent}}</td>
        <td>{{rowData.userName}}</td>
        <PushSuccessColumn :value="rowData.pushSuccess" />
        <td>{{$utils.dateText(rowData.sendDate)}}</td>
        <ReadDateColumn :value="rowData.readDate" />
      </tr>
    </tbody>
  </table>
</template>

<script>
import newsMixin from "$views/News/_mixin";
export default {
  mixins: [newsMixin],
  props: {
    sourceList: Array
  }
};
</script>

<style>
</style>